import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';

const STEPS = [
  {
    number: '01',
    titleKey: 'landing_workflow_step_01_title',
    descKey: 'landing_workflow_step_01_description',
  },
  {
    number: '02',
    titleKey: 'landing_workflow_step_02_title',
    descKey: 'landing_workflow_step_02_description',
  },
  {
    number: '03',
    titleKey: 'landing_workflow_step_03_title',
    descKey: 'landing_workflow_step_03_description',
  },
  {
    number: '04',
    titleKey: 'landing_workflow_step_04_title',
    descKey: 'landing_workflow_step_04_description',
  },
] as const;

export const WorkflowSteps: React.FC = () => {
  const { t } = useLocale();

  return (
    <section id="workflow" className="py-24 px-8 bg-[var(--scribane-black)]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <p
            className="text-[var(--scribane-green)] text-base font-medium uppercase tracking-[0.075em] mb-6"
            style={{ fontFamily: "'DM Mono', monospace" }}
          >
            {t('landing_workflow_aux')}
          </p>
          <h2 className="text-4xl sm:text-[54px] font-light text-white mb-6 leading-[1.1] tracking-[-0.02em] max-w-2xl">
            {t('landing_workflow_title')}
          </h2>
          <p className="text-gray-400 text-lg leading-[1.6] max-w-xl">
            {t('landing_workflow_subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-20 gap-y-14">
          {STEPS.map((step) => (
            <div key={step.number} className="flex gap-8">
              <div className="flex-shrink-0 w-14">
                <span
                  className="text-[40px] font-extrabold text-[var(--scribane-green)] leading-none tracking-[0.01em]"
                >
                  {step.number}
                </span>
              </div>
              <div>
                <h3 className="text-white font-bold text-[18px] leading-[32px] tracking-[0.075em] uppercase mb-2">
                  {t(step.titleKey)}
                </h3>
                <p className="text-gray-400 text-[14px] leading-[26px]">
                  {t(step.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
